import { Component, HostBinding } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { UserTermsConditionsComponent } from '../../../account/user-settings/user-terms-conditions/user-terms-conditions.component';

@Component({
    selector: 'upsc-parcel-pro-terms-conditions-link',
    templateUrl: './parcel-pro-terms-conditions-link.component.html',
    styleUrls: ['./parcel-pro-terms-conditions-link.component.scss'],
})
export class ParcelProTermsConditionsLinkComponent {
    @HostBinding('class') public hostClass = 'parcel-pro-terms-conditions-link';

    constructor(private readonly dialog: MatDialog) {
    }

    public openParcelProTermsAndConditionsDialog(event: MouseEvent): void {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        const dialogConfig: MatDialogConfig = {
            disableClose: true,
            width: '70%',
            data: {},
        };

        let dialogRef: MatDialogRef<UserTermsConditionsComponent>;
        dialogRef = this.dialog.open(UserTermsConditionsComponent, dialogConfig);

        dialogRef.afterClosed().subscribe((result) => {
        });
    }
}
